<script lang="ts">
  import DiceTray from '../dice-tray/dice-tray.svelte';
  import { selectDieData } from './modals';
  import Frame from '../components/frame.svelte';
  import Chrome from '../components/chrome.svelte';
  import type { Die } from '../models/die.type';

  let onConfirm: Function | null = null;
  let die: Die | null = null;

  selectDieData.subscribe((value) => {
    if (value && value.callback) {
      onConfirm = value.callback;
    } else {
      onConfirm = null;
    }
  });

  const confirm = () => {
    if (die) {
      die.selected = false;
    }
    if (onConfirm) {
      onConfirm(die);
    }
    selectDieData.set(null);
  };

  function chooseDie(selectedDie: Die) {
    if (selectedDie.used || !$selectDieData) {
      return;
    }
    $selectDieData.dice.forEach((die: Die) => {
      die.selected = false;
    });

    selectedDie.selected = true;
    die = selectedDie;

    // A new list, same dice: the tray redraws its dice when handed a new list,
    // and the caller still gets back the die it offered.
    $selectDieData = { ...$selectDieData, dice: [...$selectDieData.dice] };
  }
</script>

{#if $selectDieData}
  <div class="modal-container">
    <div class="modal">
      <Frame>
        <div class="header">
          <h1>Select a Die</h1>
        </div>

        <div class="body">
          <DiceTray
            dice={$selectDieData.dice}
            clickEvent={(die: Die) => {
              chooseDie(die);
            }}
            clazz="horizontal"
          />
        </div>

        <div class="functions">
          <Chrome chroming="gold" edge="circle" thickness="thin" click={confirm}>
            <div class="button">Confirm</div>
          </Chrome>
        </div>
      </Frame>
    </div>
  </div>
{/if}

<style lang="less">
</style>
